var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-overlay global-loader__overlay"},[_c('v-loader',{attrs:{"white":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }